import clsx from 'clsx';

import { useChangelog } from '~extension/changelog/hooks/useChangelog';
import useLabels from '~hooks/useLabels';
import styles from './MoreItems.module.css';

export function MoreItems() {
  const { btnChangelogLoadMore } = useLabels(['btnChangelogLoadMore']);
  const { hasMore, fetchMoreChangelogItems } = useChangelog();

  function handleClick() {
    fetchMoreChangelogItems();
  }

  if (!hasMore) {
    return null;
  }

  return (
    <div className={clsx('changelog-more', 'flex p-4 justify-center')}>
      <button
        className={clsx(
          styles.btnMore,
          'changelog-more--btn',
          'appearance-none inline-block border border-solid cursor-pointer leading-loose',
        )}
        onClick={handleClick}
      >
        {btnChangelogLoadMore}
      </button>
    </div>
  );
}
